module.exports = __webpack_public_path__ + "static/media/wallet.97fc46ed.png";